import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Config } from "src/app/config/api.config";

@Injectable({
  providedIn: "root",
})
export class FirstAccessService {
  constructor(private http: HttpClient) {}

  createPassword(createPasswordRequest: any): Observable<any> {
    return this.http.put<any>(`${Config.webApiUrl}/v1/first-access/create-password`, createPasswordRequest);
  }
}
